import React, { createContext, useState, useEffect, useContext } from 'react';
import { getAdminSettings } from '../../api/api';

const AdminSettingsContext = createContext();


export const AdminProvider = ({ children }) => {
  const [adminSettings, setAdminSettings] = useState(null);

  useEffect( async () => {
    const res= await getAdminSettings();
    console.log('AdminProvider', res);
    setAdminSettings(res);
  }, []);

  return (
    <AdminSettingsContext.Provider value={{adminSettings, setAdminSettings}}>
      {children}
    </AdminSettingsContext.Provider>
  );
};

export const useAdminSettings = () => useContext(AdminSettingsContext);